var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoorEtc = function SvgDoorEtc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4,
    y: 4,
    fill: "#fff",
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4,
    y: 4,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2.67,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 20.97a1.6 1.6 0 1 1-3.21 0 1.6 1.6 0 0 1 3.2 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.77 11.81c-.54 0-1 .16-1.32.4-.31.21-.47.47-.51.69a1.16 1.16 0 0 1-2.28-.46c.18-.9.74-1.64 1.45-2.14a4.6 4.6 0 0 1 2.66-.8c2.04 0 4.16 1.36 4.16 3.56 0 1.27-.75 2.3-1.73 2.9a1.16 1.16 0 0 1-1.21-1.98c.45-.28.62-.64.62-.92 0-.46-.57-1.25-1.84-1.25",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.77 14.9c.64 0 1.16.52 1.16 1.16v1.2a1.16 1.16 0 0 1-2.32 0v-1.2c0-.64.52-1.16 1.16-1.16",
    clipRule: "evenodd"
  })));
};
export default SvgDoorEtc;